import { AlgoliaInstantsearchComponent } from '@app-domains/algolia/components/algolia-instantsearch.component'

import { Component, Inject, OnInit } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'

import { Marker } from '@app-domains/google-maps/types/marker'

export interface FilterDialogData {
    allDealers: Marker[]
    instantSearchInstance: AlgoliaInstantsearchComponent
}

@Component({
    selector: 'app-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['./filter-dialog.component.scss'],
})
export class FilterDialogComponent implements OnInit {

    public allDealers: Marker[]

    constructor(
        @Inject(DIALOG_DATA) public data: FilterDialogData,
        public dialogRef: DialogRef<{ dealerType: string; brands: never[] }>,
    ) {
    }

    public ngOnInit(): void {
        this.allDealers = this.data.allDealers
    }

    public clearFilters(): void {
        this.data.instantSearchInstance.instantSearchInstance.helper!.setQueryParameter('aroundLatLng', undefined)
        this.data.instantSearchInstance.instantSearchInstance.helper!.setQueryParameter('aroundRadius', undefined)
        this.data.instantSearchInstance.instantSearchInstance.helper!.setQueryParameter('aroundLatLngViaIP', false)
        this.data.instantSearchInstance.instantSearchInstance.helper?.clearRefinements()
        this.data.instantSearchInstance.instantSearchInstance.helper?.search()
    }

    public showResults(): void {
        this.dialogRef.close()
    }

}
